import { EuBankStatus } from '@/components/Shared/constants/banks-statuses';
import { Button } from '@/components/Shared/ui';
import InfoCircle from '@/media/svg/info-circle.svg?react';
import { useAppDispatch, useAppSelector } from '@/store';
import { onSetSelectedBank } from '@/store/financingStep.slice';
import { setCurrent } from '@/store/newOrder.slice';

import useSelectOffer from '../../../hooks/useSelectOffer';
import type { TEurasV1BankOffer } from '../../../types/euras-v1.types';

const hideCancelButtonStatuses = [EuBankStatus.Financed];

interface IProps {
  bankOffer: TEurasV1BankOffer;
  setCancelModal?: (value: boolean) => void;
  setOfferDetailsModal: (value: boolean | string) => void;
}

const useHeaderActions = ({
  bankOffer,
  setCancelModal,
  setOfferDetailsModal
}: IProps) => {
  const dispatch = useAppDispatch();

  const { handleSelect } = useSelectOffer({ bankOffer });
  const {
    userAccesses: {
      autoCredit: { canAcceptOffer, canCancelOffer }
    }
  } = useAppSelector((state) => state.userInfo);
  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const canAccept =
    bankOffer.status.code === EuBankStatus.Approved ||
    bankOffer.status.code === EuBankStatus.AcceptedAlternative;

  const headerActions: React.ReactElement[] = [];
  if (bankOffer.isOffered && bankOffer.status.code !== EuBankStatus.Financed) {
    headerActions.push(
      <Button
        key={bankOffer.id + 'continue'}
        size="small"
        variant="filled-red"
        onClick={() => {
          if (!selectedBank) dispatch(onSetSelectedBank(bankOffer));
          dispatch(setCurrent(2));
        }}
      >
        Продолжить
      </Button>
    );
  }
  if (canAccept)
    headerActions.push(
      <Button
        key={bankOffer.id + 'accept'}
        size="small"
        variant="filled-red"
        onClick={() => handleSelect()}
        disabled={!canAcceptOffer}
      >
        Принять <span className="offer-body__hidden">предложение</span>
      </Button>
    );
  if (
    !hideCancelButtonStatuses.includes(bankOffer.status.code as EuBankStatus) &&
    setCancelModal
  ) {
    headerActions.push(
      <Button
        key={bankOffer.id + 'reject'}
        size="small"
        onClick={() => setCancelModal(true)}
        disabled={!canCancelOffer}
      >
        Отклонить
      </Button>
    );
  }

  if (bankOffer.bankDescription)
    headerActions.push(
      <Button
        key={bankOffer.id + 'description'}
        onClick={() => setOfferDetailsModal(true)}
        size="small"
      >
        <InfoCircle />
        Описание
      </Button>
    );

  return { headerActions };
};

export default useHeaderActions;
